module.exports = __webpack_public_path__ + "img/progreso_2.cf012f17.svg";